import { render, staticRenderFns } from "./Senser.vue?vue&type=template&id=2f7a1224&"
import script from "./Senser.vue?vue&type=script&lang=js&"
export * from "./Senser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports